import React, { useState, useRef } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import TemplateAction from './templateAction';
import API_CALLS from 'API_CALLS/index';
import AlignerImage from 'global/img/aligner.jpg';
import ReactToPrint from 'react-to-print';
import {QRCodeSVG} from 'qrcode.react';
import DialogProgressLogs from 'admin/components/DialogProgressLogs/index';
import LayoutBuilder from 'LayoutBuilder';

const {Container, Row, Column} = LayoutBuilder;
/*

//GET AND SHOW CURRENT USER
//CREATE NEW OBJECT FOR NEW TREATMENT PLAN
//SAVE NEW PLAN
//SEND DOCTOR AN EMAIL WITH A LINK
//CC DAD ON THE EMAIL WITH THE LINK
//CLOSE CURRENT TASK
//CREATE NEW TASK WITH (UPLOAD_TREATMENT_PLAN)
  //USER ID (UID)
  //ALIGNMENT PLAN ID (TPID)
  //

 
*/





const FORM_FIELDS = (obj)=>{
  return [
    {
      title: <div className="formTitle"><span className="">Tracking Number</span></div>,
      subTitle: <div className="formSubTitle"><span className="">The number for the user to track their shipment</span></div>,
      type: "text",
      name: "trackingNumber",
      required: false,
      defaultValue: "",
      formatInput: (inputValue)=>{
        if(!inputValue) return inputValue;
        return inputValue.toUpperCase();
      },
      errorMessage: "Name is required"
    },
    {
      title: <div className="formTitle"><span className="">Tracking Company</span></div>,
      subTitle: <div className="formSubTitle"><span className="">The name of the company who we used to ship the package.</span></div>,
      type: "selectAPIWithAdd",
      onMount: (callBack) => {
        window.Client.query({
          query: API_CALLS.ORDER_ITEMS.QUERIES.distinct(),
          variables: {
            field: "trackingCompany" //FIELD TO GET ALL OPTIONS
          },
          fetchPolicy: "no-cache"
        })
        .then(result => {
          //console.log("result.data","\n\n",result.data,"\n\n");
          var fullOptionList = result.data.orderItemDistinct.map((DisOption, index)=>{
            return({
              "value": DisOption,
              "title": DisOption
            })
          });
          fullOptionList = fullOptionList.filter((obj) => (obj.value));
          var DefaultValues = [
            {
              "value": "",
              "title": "Choose one",
              "disabled": true
            },
            {
              "value": "USPS",
              "title": "USPS"
            },
            {
              "value": "UPS",
              "title": "UPS"
            }
          ];
          const uniqueArray = window.GlobalUtil.arrayOfObjectsOnlyUnique([...DefaultValues, ...fullOptionList], "value");
          window.GlobalUtil.consoleLogNew({LOCATION:`src/admin/pages/shipping/actions/SendAligners`, NAME:`uniqueArray`, CONTENT:[uniqueArray]});
          callBack("options", uniqueArray)
        });
      },
      name: "trackingCompany",
      required: false,
      defaultValue: "",
      defaultValuePath: "trackingCompany",
      errorMessage: "This is required"
    },
    {
      title: <div className="formTitle"><span className="">Send Email</span></div>,
      subTitle: <div className="formSubTitle"><span className="">Should we send an email to user telling them their order was sent?</span></div>,
      type: "toggle",
      name: "sendEmail",
      borderBottom: true,
      borderTop: true,
      defaultValue: false,
      defaultValuePath: "sendEmail"
    }
  ]
}




class Index extends TemplateAction {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state
    }; 
  }

  validate = (dontFinish, callback) => {
    var curObj = {...this.curObj};
    curObj = window.GlobalUtil.stripOutFromObj(curObj, "__typename")
    Object.keys(curObj).map((key, index)=>{
      if((curObj[key]  === undefined) || (curObj[key]  === "")) delete curObj[key] 
    })
    this.APIUpdate(curObj, dontFinish, callback);
  }


  APIGet = () => { 
    //console.log(`this.props.curObj`,"\n\n",this.props.curObj,"\n\n");
    this.curObj = {
      id: this.props.curObj._id, 
      trackingNumber: this.props.curObj.trackingNumber, 
      trackingCompany: this.props.curObj.trackingCompany,
      sendEmail: false 
    };    
    window.CurObj = {...this.curObj};


    var inputObj = {
      query: API_CALLS.USERS.QUERIES.single(),
      variables: {
        id: this.props.curObj.UID
      },
      fetchPolicy: "no-cache"
    }
    window.Client.query(inputObj)
    .then((obj) => {
      var {data, loading} = obj;            
      var CurUserObj = window.GlobalUtil.stripOutFromObj(data.user, "__typename");
      //console.log("CurUserObj","\n\n",CurUserObj,"\n\n");
      if(!this) return;
      this.setState({User: CurUserObj, hideForm: true}, ()=>{
        this.setState({hideForm: false})
      })
    })
    .catch((error)=>{
      console.log("query plan failed", error);
    });
  }


  APIUpdate = (newObj, dontFinish, callback=()=>{}) => {
    var inputObj = {
      mutation: (dontFinish ? API_CALLS.ORDER_ITEMS.MUTATIONS.update() : API_CALLS.ORDER_ITEMS.MUTATIONS.shipped()),
      variables: (dontFinish ? newObj : {id: newObj.id, sendEmail: newObj.sendEmail})
    }
    console.log("What we're sending","\n\n",inputObj.variables,"\n\n");
    window.Client.mutate(inputObj)
    .then((obj) => {
      var {data, loading} = obj;
      if(!dontFinish) {
        window.CurRefetchList(true);
        callback()
        if(this.onClose) this.onClose(this.CurRef);
      }
    })
    .catch((error)=>{
      console.log("Reject APIUpdate shipped catch catch", error);
      if(this.onClose) this.onClose(this.CurRef);
    });
  }



  render(){
    const PREVIEWALIGNER = this.PREVIEWALIGNER;
    var Table = this.Table;
    var ComponentToPrint = this.ComponentToPrint;
    var ToLabel = this.ToLabel;
    var {isValid, User={}, hideForm, ShowPreview} = this.state;    
    var OrderItem = this.props.curObj;
    var ItemsArray = (OrderItem.itemsStringArray ? JSON.parse(OrderItem.itemsStringArray) : []);
    var {address={}} = User;
          
    return (
      this.SlideInRight(
        "Ship Aligners", 
        (curRef)=>{
          this.CurRef = curRef;
          return(
            <React.Fragment>
              <div className="buttonGroup">
                <button className="button button2 btn-color6" onClick={()=>{
                  if(curRef) curRef.onClose()
                }}>Close</button>
                <button className={`button button1`} onClick={()=>{ 
                  this.validate();
                }}>Shipped <i className="fas fa-shipping-fast"></i></button>
              </div>
              <DialogProgressLogs
                ID={this.props.curObj._id}
                API_NAME={'ORDER_ITEMS'}
                FIELD={'orderItem'}
                asButton={true}
                className={'button button1 btn-color4'}
                style={{"width":"100px","minWidth":"0"}}
                customLinkText={<span><span>Logs</span>&nbsp;&nbsp;<i className="fas fa-clipboard-list"/></span>}
              />
            </React.Fragment>
          )
        }, 
        ()=>{
          return(
            <div className="">
              <div className="PreviewForm">
                {
                  User.address &&
                  this.previewUser(User)
                }
                <Row className="">
                  <Column className="" sm="" md="" lg="" xl="">
                    <div className="previewFormFieldTitles">
                      <div className="previewFormFieldTitle">What to ship</div>
                    </div>
                    <Table
                      HEADERS={["Image", "Name", "Aligner ID", "Check QR"]}
                      ROWS={ItemsArray.map((items, index)=>{
                        return(
                          [
                            (<img src={AlignerImage} alt="" className="" style={{width: "80px", "margin": "0 0 0 -12px"}} />),
                            "Aligner",
                            <a href="" style={{"fontWeight": "500"}} onClick={(e)=>{
                              e.preventDefault();
                              this.setState({
                                ShowPreview: ()=><PREVIEWALIGNER
                                  VARIABLES={{
                                    id: items.id
                                  }}
                                />
                              });
                            }}>{items.id}</a>,
                            (<CodeScanner id={items.id}/>)
                          ]
                        )
                      })}
                    />
                  </Column>
                </Row>
                <Row className="">
                  <Column className="" sm="" md="" lg="" xl="">
                    <div className="previewFormFieldTitles">
                      <div className="previewFormFieldTitle">Shipping Label</div>
                    </div>
                    <div className="">
                      <Row className="">
                        {/*<Column className="" col="12" sm="12" md="6" lg="6" xl="6">
                          <FromLabel />
                          <br/>
                        </Column>*/}
                        <Column className="" col="12" sm="12" md="12" lg="12" xl="12">
                          <ToLabel User={User}/>
                          <br/>
                          <div className="buttonGroup right">
                            <ReactToPrint
                              trigger={() => <button className="button button1">Print Shipping Address</button>}
                              content={() => this.CompToPrintRef}
                            />
                          </div>
                        </Column>
                      </Row>
                      <div style={{ display: "none" }}>
                        <ComponentToPrint
                          ref={e=>this.CompToPrintRef=e}
                          copyStyles={true}
                          User={User}
                        />
                      </div>
                    </div>
                  </Column>
                </Row>
                <div className="previewFormFieldTitles">
                  <div className="previewFormFieldTitle">Tracking Information</div>
                </div>
              </div>
              {this.FormBuilderZone(FORM_FIELDS)}
            </div>
          )
        }
      )
    );
  }
}





class CodeScanner extends  React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }; 
    this.clickOutside = this.clickOutside.bind(this);
    this.starScanning = this.starScanning.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.clickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.clickOutside, true);
    clearTimeout(this.CodeTimeout);
  }

  starScanning(){
    this.setState({scanningCode: true}, ()=>{
      if(this.InputRef) this.InputRef.focus();
    });
  }

  clickOutside(event) {
    if (!event.target.parentNode || !event.target.isConnected) return;          
    if (this.InputRef && !this.InputRef.contains(event.target)) {
      this.setState({scanningCode: false});
    }
  }

  handleChange(e){
    var newValue = e.target.value;
    this.setState({currentCode: newValue}, ()=>{
      if(this.CodeTimeout) clearTimeout(this.CodeTimeout);
      this.CodeTimeout = setTimeout(()=>{
        var codeMatched = (this.state.currentCode === this.props.id);
        this.setState({
          codeMatched: codeMatched, 
          scanningCode: false,
          currentCode: ""
        })
      }, 500);
    })
  }

  render(){
    var {scanningCode, codeMatched, currentCode=""} = this.state;
    return (
      <div>
      {
        scanningCode 
        ? <React.Fragment>
            <button className="button button1 buttonSmall btn-color4" onClick={()=>{
              this.setState({scanningCode: false})
            }}>Ready&nbsp;&nbsp;<i className="fas fa-qrcode"></i></button>
            <input 
              value={currentCode}
              type="text" 
              className="text" 
              onChange={this.handleChange}
              ref={e=>this.InputRef = e}
              style={{"overflow":"hidden","height":"0px","width":"0px","border":"none","boxShadow":"none","padding":"0","margin":"0"}}
            />
          </React.Fragment>
        : codeMatched === undefined
          ? <button 
              className="button button2 buttonSmall btn-color4" 
              onClick={this.starScanning}>Scan Code&nbsp;&nbsp;<i className="fas fa-qrcode"/>
            </button>
          : <button 
              className={`button button2 buttonSmall btn-color${codeMatched ? "2" : "5"}`} 
              onClick={this.starScanning}>{codeMatched ? "Matched" : "Not a Match"}&nbsp;&nbsp;<i className="fas fa-qrcode"/>
            </button>
      }
      </div>
    )
  }
}




export default Index;
export {CodeScanner};